var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApploadingWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7 29.046C50.6998 29.0307 50.6997 29.0153 50.6997 29C50.6997 17.0154 40.9843 7.3 28.9999 7.3C17.0307 7.3 7.3249 16.9906 7.30007 28.954C7.30027 28.9693 7.30037 28.9846 7.30037 29C7.30037 40.9846 17.0157 50.7 29.0002 50.7C40.9694 50.7 50.6752 41.0094 50.7 29.046ZM0.300417 29.0529C0.300157 29.0353 0.300026 29.0177 0.300026 29C0.300025 13.1495 13.1494 0.300003 28.9999 0.300003C44.8328 0.300003 57.6712 13.1209 57.6997 28.9471C57.6999 28.9647 57.7001 28.9824 57.7001 29C57.7001 44.8506 44.8507 57.7 29.0002 57.7C13.1673 57.7 0.328945 44.8791 0.300417 29.0529Z",
    fill: "#EAF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2001 29C54.2001 42.9176 42.9178 54.2 29.0003 54.2C15.0828 54.2 3.80042 42.9176 3.80042 29",
    stroke: "#0075DB",
    strokeWidth: 7,
    strokeMiterlimit: 2.61313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApploadingWheel);
export default __webpack_public_path__ + "static/media/app.loading_wheel.c17c4d88c0dbe58bf3ea8203e5eee6a4.svg";
export { ForwardRef as ReactComponent };